import { render, staticRenderFns } from "./VehicleRlsWrite.vue?vue&type=template&id=61cd3f5c&scoped=true"
import script from "./VehicleRlsWrite.vue?vue&type=script&lang=js"
export * from "./VehicleRlsWrite.vue?vue&type=script&lang=js"
import style0 from "./VehicleRlsWrite.vue?vue&type=style&index=0&id=61cd3f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd3f5c",
  null
  
)

export default component.exports